import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { busTimesMachine } from './bus-times.machine';
import type { RouteId } from './events';

export const useBusTimesRef = () => feature('bus-times');
export const useBusTimes = <Result>(selector: (snapshot: SnapshotFrom<typeof busTimesMachine>) => Result) =>
  useFeature('bus-times', selector);

export function useBusTimesActions() {
  const ref = useBusTimesRef();
  return {
    chooseRoute: (routeId: RouteId) => ref.send({ type: 'bus-times.choose-route', routeId }),
    chooseDirection: (directionId: string) => ref.send({ type: 'bus-times.choose-direction', directionId }),
    chooseStop: (stopId: string) => ref.send({ type: 'bus-times.choose-stop', stopId }),
    viewSchedule: () => ref.send({ type: 'bus-times.view-schedule' }),
    refreshSchedule: () => ref.send({ type: 'bus-times.refresh-schedule' }),
  };
}
